import axios, { InternalAxiosRequestConfig, AxiosError } from 'axios'
import { API_CONFIG } from '../config'
import { getAuthToken } from '@trafiflow/shared-ui'

const apiClient = axios.create({
  baseURL: API_CONFIG.baseUrl,
  timeout: API_CONFIG.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para agregar token de autenticación
// API Gateway Cognito User Pools Authorizer expects: Authorization: Bearer <token>
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    try {
      const token = await getAuthToken()
      if (token && config.headers) {
        // API Gateway Cognito authorizer expects "Bearer " prefix
        config.headers.Authorization = `Bearer ${token}`
        console.log('[API] ✅ Token attached to request:', config.url)
      } else {
        console.warn('[API] ⚠️ No token available for request:', config.url)
      }
    } catch (error) {
      console.error('[API] ❌ Error getting token:', error)
    }
    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar errores de respuesta
// NOTE: We don't redirect on 401 here - ProtectedRoute handles auth redirects
// This prevents redirect loops when checking connection status
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      console.debug('API returned 401 - letting ProtectedRoute handle auth redirect')
    }
    return Promise.reject(error)
  }
)

export default apiClient

